import { render } from "./CollaborationIndex.vue?vue&type=template&id=27fee043"
import script from "./CollaborationIndex.vue?vue&type=script&lang=js"
export * from "./CollaborationIndex.vue?vue&type=script&lang=js"

import "./CollaborationIndex.vue?vue&type=style&index=0&id=27fee043&lang=css"

import exportComponent from "/Users/ratul/Code/vue/jourly-admin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__